import { NavLink, Outlet } from 'react-router-dom';

const navItems = [
  { to: '/admin', label: 'Resumen', icon: '📊', end: true },
  { to: '/admin/usuarios', label: 'Usuarios', icon: '👥', end: false },
  { to: '/admin/trades', label: 'Trades', icon: '🔄', end: false },
  { to: '/admin/inventario', label: 'Inventario', icon: '📋', end: false },
];

export default function AdminLayout() {
  return (
    <div className="flex min-h-[calc(100vh-56px)] bg-[#111122]">
      {/* Sidebar */}
      <aside className="w-36 shrink-0 bg-[#0d0d1c] border-r border-[#1e1e30]">
        <div className="px-3 py-3 text-xs font-bold tracking-widest text-gold-400 uppercase">
          Admin
        </div>
        <nav className="flex flex-col" aria-label="Admin navigation">
          {navItems.map(({ to, label, icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? 'text-gold-400 bg-[#1a1a2e] border-l-2 border-gold-400'
                    : 'text-white/50 hover:text-white/80'
                }`
              }
            >
              <span aria-hidden="true">{icon}</span>
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Main content */}
      <main className="flex-1 p-5 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
